import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import {
  submitCreateUserProducerInformation,
  submitUpdateUserProducerInformation
} from '~/api/data/users/mutations';
import {
  loadCurrentUser,
  loadMyTeams,
  loadUserProducerInformations
} from '~/api/data/users/queries';
import {
  SettingsProfilePage,
  UserProducerInformationCreatePage,
  UserProducerInformationEditPage
} from '~/pages/settings';

export const profileRoute: RouteObject = {
  path: 'profile',
  loader: merge({
    agencyUser: loadCurrentUser,
    producerInformations: loadUserProducerInformations,
    myTeams: loadMyTeams
  }),
  element: <SettingsProfilePage />,
  children: [
    {
      path: 'producer-information/new',
      action: byMethod({
        POST: submitCreateUserProducerInformation
      }),
      element: <UserProducerInformationCreatePage />
    },
    {
      path: 'producer-information/:id/edit',
      loader: merge({
        producerInformations: loadUserProducerInformations
      }),
      action: byMethod({
        PUT: submitUpdateUserProducerInformation
      }),
      element: <UserProducerInformationEditPage />
    }
  ]
};
